import { Component, OnInit } from '@angular/core';
import { UserService } from "../services/user/user.service";
import { B2cService } from "../services/b2c/b2c.service";
import { CartService } from "../services/cart/cart.service";
import {Router} from "@angular/router"

declare var $: any;

@Component({
  selector: 'app-connexion',
  templateUrl: './connexion.component.html',
  styleUrls: ['./connexion.component.css']
})
export class ConnexionComponent implements OnInit {
  email:String;
  password:String;
  card;
  typeCompte:String="Entreprise";
  typeCompteChange:String="Entreprise";
  firstname:String="";
  lastname:String="";
  emailUser:any;
  pwd:String="";
  pwd1:String="";
  msg=""
  success=""
  msgLogin=""
  msgLoginChange=""
  successLogin=""
  changePassword = {username:'',mail:''};
  successChange = false;
  errorRequis   = false;
  errorEmail = false;
  constructor(public userService:UserService,private router: Router,private cartService:CartService,private b2cService:B2cService) { }

  ngOnInit(): void {
    $( document ).ready(function() {
      $( ".subscribePage" ).hide();
      $( ".MDPPage" ).hide();
      $( ".showsub" ).click(function() {
      $( ".subscribePage" ).show( "slow", function() {
      // Animation complete.
      });
      $( ".connexionPage" ).hide( "slow", function() {
      // Animation complete.
      });
      });

      $( ".oublieMdp" ).click(function() {
      $( ".MDPPage" ).show( "slow", function() {
      // Animation complete.
      });
      $( ".subscribePage" ).hide( "slow", function() {
      // Animation complete.
      });
      $( ".connexionPage" ).hide();

      });
      $( ".btnalreadysub" ).click(function() {
      $( ".connexionPage" ).show( "slow", function() {
      // Animation complete.
      });
      $( ".subscribePage" ).hide( "slow", function() {
      // Animation complete.
      });
      $( ".MDPPage" ).hide();
      $( ".subscribePage" ).hide();
      })

      $('.goSearch').click(function(){
        $('.searchContainer').show('slow');
      });

      $('.searchForm').change(function(){
        $('.Searching').removeClass('col-12').addClass('col-12 col-md-4');
        $('.catSearch').show('slide');
      });

      $('.closeSearch,.searchPlus').click(function(){
        $('.searchContainer').hide('slide');
      });
      $('.dropdown-menu a').click(function(){
        $('.MenuBar').click();
      })
  });
  }
  loginSend(event){
    if (event.keyCode === 13) {
      this.login()
    }
  }
  login()
  {

     if(this.typeCompte == 'Entreprise'){
       this.loginB2B()
     }
     if(this.typeCompte == 'Particulier'){
       this.loginB2C()
     }
  }

  loginB2B(){
    this.userService.login({username:this.email,password:this.password}).subscribe(res =>{
      if (res.status==true) {
        this.msgLogin = ""
        localStorage.setItem('user',JSON.stringify(res.user))
        localStorage.setItem('token',res.token)
        localStorage.setItem('typeCompte','B2B')
        this.removeExtraItem();
        if(JSON.parse(localStorage.getItem('card')) !=null)
        {
          this.card = JSON.parse(localStorage.getItem('card'));
          this.cartService.getCart().subscribe(res=>{
            this.card.forEach(elementCart => {
              var tempProduct = res['cart'].filter(c => c.ITMREF ==  elementCart.product.ITMREF);
              if (tempProduct.length > 0) {
                this.cartService.updateItemCart([{
                    "item_ref": elementCart.product.ITMREF,
                    "item_quantity": parseInt(elementCart.item_quantity)
                }]).subscribe(res=>{})

              }else{
                this.cartService.addTocart({
                  "item_ref" : elementCart.product.ITMREF,
                  "item_quantity" : elementCart.item_quantity,
                  "item_price" : elementCart.product.PRIXNET
                }).subscribe(res=>{});
              }
            });
          })
        }
        this.router.navigate(['/b2b'])
      }
    },err=>{
      console.log("error",err);
      this.msgLogin = "Email ou mot de passe incorrect!"
    })
  }
  loginB2C(){
    this.b2cService.login({email:this.email,pwd:this.password}).subscribe(res =>{
      if(res.status){
        localStorage.setItem('user',JSON.stringify(res.user))
        localStorage.setItem('typeCompte','B2C')
        this.msgLogin = ""
        this.router.navigate(['/moncompte'])
      }else{
        this.msgLogin = res.msg
      }
    })
  }

  addUser(){

    if(this.pwd==this.pwd1){
      var data ={firstname:this.firstname,lastname:this.lastname,email:this.emailUser,pwd:this.pwd}
      if(this.errorEmail == false){
        this.b2cService.addUser(data).subscribe(res =>{
          console.log(res);
          if(res.status){
            this.firstname ="";
            this.lastname ="";
            this.emailUser = "";
            this.pwd ="";
            this.pwd1 ="";
            this.msg = ""
            this.success = res.msg
            setTimeout(() => {
              this.router.navigate(['/moncompte'])
            }, 2500);
          }else{
            this.msg = res.msg
          }
  
        })
      }
      

    }else{
      this.msg = "le mot de passe ne correspond pas"
    }
  }
  checkEmail(){
    if(this.emailUser != ''){
      var re = /\S+@\S+\.\S+/;
      this.errorEmail = !re.test(this.emailUser);
    }
  }
  removeExtraItem()
  {

    this.cartService.getCart().subscribe(res=>{
      this.card = JSON.parse(localStorage.getItem('card'));
        if (this.card) {
          var tempProduct = [];
          res['cart'].forEach(elementCart => {
            tempProduct = this.card.filter(c => c.product.ITMREF ==  elementCart.ITMREF);
            if (tempProduct.length==0)
            {
              this.cartService.removeFromCart(elementCart.ITMREF).subscribe(res=>{})
            }
            tempProduct = [];
          });
        }else{
          res['cart'].forEach(elementCart => {
              this.cartService.removeFromCart(elementCart.ITMREF).subscribe(res=>{})
          });
        }


    })


  }

  changePasswordAction(){
    this.changePassword.mail = this.emailUser
     if(this.changePassword.username !="" && this.changePassword.mail !=""){
      if(this.typeCompteChange == 'Entreprise' && !this.errorEmail){
        this.userService.resetPassword(this.changePassword).subscribe(res=>{
          if(res['status']){
            this.successChange       = true
            this.errorRequis   = false;
          }
        })
      }else if(this.typeCompteChange == 'Particulier'){
        this.b2cService.changePassword({email:this.changePassword.mail}).subscribe(res =>{
          if(res.status){
            this.b2cService.sendMail({"username":this.changePassword.username,"password": res.newPassword,"mail": this.changePassword.mail}).subscribe(res =>{
              if(res['status']){
                this.successChange = true
                this.errorRequis   = false;
                this.msgLoginChange = ''
              }
            })
          }else{
            this.msgLoginChange = res.msg
          }
        })
      }
       
     }else{
       this.successChange       = false;
       this.errorRequis   = true;
     }
  }

}
